<div class="header_panel" id="routeStepsContent">
  <!-- itera los días -->
  <!-- Itera los grupos -->
   
   <!-- fecha cabeza del primer grupo -->
   <div class="row text-header">
    <div class="section-header-background">
      <h3> {{ setGroupStepsRouteDate(groupStepsRouteDTO[0].sDateGroup) }}</h3>
    </div>
  </div>

  <div *ngFor="let group of groupStepsRouteDTO">
    <!-- fecha cabeza de cada grupo -->
    <!-- si la fecha es diferente a la última fecha, se actualiza la última fecha -->
    <ng-container *ngIf="group.sDateGroup != shownDate && shownFirst">
      <div class="row text-header">
        <div class="section-header-background">
          <h3> {{ setGroupStepsRouteDate(group.sDateGroup) }}</h3>
        </div>
      </div>
    </ng-container>
    <div class="itemGroup">
      <div [id]="group.idGroup" class="row itemPanel" [ngClass]="group.typeStep == 'Apagado' ? 'cardApagado' : 'cardTrayecto'"  (click) ="onClickGroup(group.idGroup)">
        <div *ngIf="group.typeStep == 'Apagado'"><img class="imgDetail parking" src="/assets/img/parking.png"></div>
        <div *ngIf="group.typeStep == 'Trayecto'"><img class="imgDetail" src="/assets/img/moving.png"></div>
        <div class="col-md-1 itemHour">
          <img class="imgDefaultCard" src="/assets/img/itemDetailRoute.PNG" />
        </div>
        <div class="col-md-10">
          <div class="titleStatus">{{group.typeStep}} ({{group.idGroup}}) </div>
          <div class="row">
            <div class="col-md-4 itemHour">
              <mat-icon class="itemImg">timer</mat-icon>&nbsp;<label class="itemKm">{{group.horaInicioGroup}} </label>
            </div>
            <div class="col-md-4">
              <mat-icon class="itemImg">directions_car</mat-icon>&nbsp;<label class="itemKm">{{group.sDistanceGroup}}</label>
            </div>
            <div class="col-md-4 itemMin">
              <mat-icon class="itemImg">schedule</mat-icon>&nbsp;<label class="itemKm">{{group.sElapsedGroup}} </label>
            </div>
          </div>
        </div>

        <!-- Botón para expandir/contraer -->
        <div class="col-md-1 group-button-container">
          <button class="group-button" mat-icon-button (click)="group.showDetails = !group.showDetails; $event.stopPropagation()">
            <mat-icon style="color: white">{{ group.showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>

      </div>
    </div>
    <!-- Itera los pasos -->
     <div *ngIf="group.showDetails">
      <div *ngFor="let detail of group.steps">
        <div class="itemSingle">
          <div class="row itemPanelChild" [ngClass]="detail.typeStep == 'Encendido' ? 'cardEncendido' : detail.typeStep == 'Moviendo' ? 'cardMoviendo' : 'cardApagado'" (click)="onClickStep(detail, group.idGroup)">
            <div *ngIf="detail.typeStep == 'Encendido'"><img class="imgDetail" src="/assets/img/starting.png"></div>
            <div *ngIf="detail.typeStep == 'Trayecto'"><img class="imgDetail" src="/assets/img/moving.png"></div>
            <div *ngIf="detail.typeStep == 'Apagado'"><img class="imgDetail" src="/assets/img/parking.png"></div>
            <div class="col-md-1 itemHour"></div>
            <div class="col-md-11">
              <div class="titleStatus">{{detail.id}}. {{detail.typeStep}}</div> 
              <div *ngIf="detail.typeStep == 'Encendido' || detail.typeStep == 'Apagado'" class="titleDirection">{{detail.direction}}</div> 
              <div class="row">
                <div class="col-md-4 itemHour">{{getTimePeriod(detail.sHoraInicial)}}</div>
                <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;{{detail.distance}} Km</div>
                <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;{{detail.sElapsed}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>
    
  </div>
  

  <!-- <div class="itemSingle">
                <div class="row itemPanelChild cardApagado">
                  <div><img class="imgDetail" src="/assets/img/parking.png"></div>
                  <div class="col-md-2 itemHour"></div>
                  <div class="col-md-10">
                    <div class="titleStatus">Apagado</div> 
                    <div class="titleDirection">Av. Aguascalientes 1023 Colonia del Trabajo 20200, Aguascalientes, Ags.</div> 
                    <div class="row">
                      <div class="col-md-4 itemHour"><mat-icon>access_time</mat-icon>&nbsp;08:25am</div>
                      <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;2.8Km</div>
                      <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;05 min</div>
                    </div>
                  </div>
                </div>
              </div> -->
  <!-- </div> -->
  <!-- <div class="itemGroup">
            <div class="row itemPanel cardTrayecto">
              <div><img class="imgDetail" src="/assets/img/moving.png"></div>
              <div class="col-md-2 itemHour"><img class="imgDefaultCard" src="/assets/img/itemDetailRoute.PNG"></div>
              <div class="col-md-10">
                <div class="titleStatus">Trayecto 1</div> 
                <div class="row">
                  <div class="col-md-4 itemHour"><mat-icon>access_time</mat-icon>&nbsp;08:25am</div>
                  <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;2.8Km</div>
                  <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;05 min</div>
                </div>
              </div>
            </div>
            <div class="itemSingle">
              <div class="row itemPanelChild cardEncendido">
                <div><img class="imgDetail" src="/assets/img/starting.png"></div>
                <div class="col-md-2 itemHour"></div>
                <div class="col-md-10">
                  <div class="titleStatus">Encendido</div> 
                  <div class="titleDirection">Av. Aguascalientes 1023 Colonia del Trabajo 20200, Aguascalientes, Ags.</div> 
                  <div class="row">
                    <div class="col-md-4 itemHour"><mat-icon>access_time</mat-icon>&nbsp;08:25am</div>
                    <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;2.8Km</div>
                    <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;05 min</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="itemSingle">
              <div class="row itemPanelChild cardMoviendo">
                <div><img class="imgDetail" src="/assets/img/onRoute.png"></div>
                <div class="col-md-2 itemHour"></div>
                <div class="col-md-10">
                  <div class="titleStatus">Moviendo</div> 
                  <div class="row">
                    <div class="col-md-4 itemHour"><mat-icon>access_time</mat-icon>&nbsp;08:25am</div>
                    <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;2.8Km</div>
                    <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;05 min</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="itemSingle">
              <div class="row itemPanelChild cardApagado">
                <div><img class="imgDetail" src="/assets/img/parking.png"></div>
                <div class="col-md-2 itemHour"></div>
                <div class="col-md-10">
                  <div class="titleStatus">Apagado</div> 
                  <div class="titleDirection">Av. Aguascalientes 1023 Colonia del Trabajo 20200, Aguascalientes, Ags.</div> 
                  <div class="row">
                    <div class="col-md-4 itemHour"><mat-icon>access_time</mat-icon>&nbsp;08:25am</div>
                    <div class="col-md-4 itemKm"><mat-icon>directions_car</mat-icon>&nbsp;2.8Km</div>
                    <div class="col-md-4 itemMin"><mat-icon>timer</mat-icon>&nbsp;05 min</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
</div>
